
import React from 'react';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { RootState } from '../store';

export type singleModalType = {
  [key: string]: {
    isOpen: boolean;
    onClose?: () => void;
    onSubmit?: () => void;
    data?: Record<string, unknown>;
  };
};

export interface ModalState {
  modals: singleModalType;
}

const initialState: ModalState = { modals: {} };

const modalSlice = createSlice({
  name: 'modals',
  initialState,
  reducers: {
    openModal: (
      state,
      action: PayloadAction<{
        id: string;
        content?: React.ReactNode;
        onClose?: () => void;
        onSubmit?: () => void;
        data?: Record<string, unknown>;
      }>
    ) => {
      state.modals[action.payload.id] = {
        isOpen: true,
        onClose: action?.payload?.onClose,
        onSubmit: action?.payload?.onSubmit,
        data: action?.payload?.data,
      };
    },
    closeModal: (state, action: PayloadAction<{ id: string }>) => {
      if (state.modals[action.payload.id]) {
        state.modals[action.payload.id].isOpen = false;
        state.modals[action.payload.id].data = undefined;
      }
    },
    clearModals: (state) => {
      state.modals = {};
    },
  },
});

export const { openModal, closeModal, clearModals } = modalSlice.actions;
export const useModal = () => useSelector((state: RootState) => state.modals);
export default modalSlice;
